// Component names that InsightsComponent no longer renders. Saved reports may still contain them; they are left out
// of the layout and dropped when a report is edited, so the next save removes them.
export const REMOVED_INSIGHT_COMPONENTS = new Set(['burnUp', 'cummulativeFlow']);

export const isRemovedInsightComponent = componentName => REMOVED_INSIGHT_COMPONENTS.has(componentName);

export const withoutRemovedInsightComponents = components =>
	components ? components.filter(component => !isRemovedInsightComponent(component.componentName)) : components;
